import { SvgIconDefinition } from '@am/icons-common-types';
const width = 128;
const height = 128;
const path = `M2.691,56.492C1.208,56.492,0,57.701,0,59.184v13.45c0,1.483,1.208,2.692,2.691,2.692h112.992c1.483,0,2.692-1.209,2.692-2.692V2.691c0-1.483-1.209-2.691-2.692-2.691H91.467c-1.476,0-2.684,1.208-2.684,2.691v16.142H61.875c-1.483,0-2.692,1.209-2.692,2.692v16.142h-26.9c-1.483,0-2.692,1.209-2.692,2.684v16.142H2.691z`;

export const aciNoElevators: SvgIconDefinition = {
  iconName: 'no-elevators',
  iconData: [height, width, path],
};
